import React, { useEffect } from "react";

import IconLocation from "@/icons/icon_location.svg";
import { cn } from "@/utils/cn";

import styles from "./style.module.scss"; // Will use styles from the SearchLocation modal's SCSS

interface SearchLocationInputProps
  extends React.InputHTMLAttributes<HTMLDivElement> {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
  placeholder?: string;
  inputRef?: React.RefObject<HTMLInputElement | null>;
  isActive?: boolean;
  isIconActive?: boolean;
}

const SearchLocationInput: React.FC<SearchLocationInputProps> = ({
  value,
  onChange,
  onClick,
  placeholder,
  inputRef,
  isActive,
  isIconActive,
  className,
}) => {
  useEffect(() => {
    const handleFocus = (e) => {
      e.preventDefault();
      const scrollTop = window.pageYOffset;
      const scrollLeft = window.pageXOffset;

      setTimeout(() => {
        window.scrollTo(scrollLeft, scrollTop);
      }, 0);
    };

    const input = inputRef?.current;
    if (input) {
      input.addEventListener("focus", handleFocus);
      return () => input.removeEventListener("focus", handleFocus);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={cn(
        "relative flex items-center w-full bg-white h-[var(--filter-btn-height)] border border-solid rounded-[1.5rem] transition-[border-color] duration-300 ease-in-out shadow shadow-gray-100/25",
        isActive && "!border-red md:z-[var(--z-index-modal)]", // Use a specific class for active state
        !isActive && "border-gray-100",
        className,
      )}
    >
      <input
        ref={inputRef}
        type="text"
        className={styles.searchLocationInput}
        placeholder={placeholder}
        value={value}
        onInput={onChange} // Changed from onInput to onChange to match standard React prop name
        onClick={onClick}
      />
      <IconLocation
        className={cn(
          styles.searchLocationInputIcon,
          isIconActive && "text-red",
        )}
      />
    </div>
  );
};

export default SearchLocationInput;
